import { fetchWithAuth } from "../../config/axios.ts";

type RequestInitExtended = RequestInit & { params?: Record<string, number | Date | string> };

export async function fetchFromContador<T>(path: string, init?: RequestInitExtended): Promise<T> {
    const response = await fetchWithAuth.request({
        url: `/contador${path}`,
        method: init?.method || "GET",
        data: init?.body ? JSON.parse(init.body as string) : undefined,
    });

    return response.data;
}
